#### Webhook Playground

We’ve added a [Webhook Playground] to the Developer Dashboard that allows you to send a variety of mock events to your webhook endpoint and review the response received by the SEEK API.

The mock events sent using this tool contain references to [mock objects] that can be queried with [Playground credentials].

This will allow you to develop your software with a much faster feedback loop, since you can easily send a mock event at the click of a button, rather than having to perform any real actions on SEEK.

[webhook playground]: /manage/webhook-playground
[mock objects]: /graphql/playground/mock-objects
[playground credentials]: /graphql/playground#authentication
